import { render } from "./popupMandiri.vue?vue&type=template&id=7b4ffe7e"
import script from "./popupMandiri.vue?vue&type=script&lang=js"
export * from "./popupMandiri.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__